import { Spin } from 'antd';

const FullPageSpinner = () => {
    return (<Spin spinning={true} fullscreen={true} />)
};

export default FullPageSpinner;


